import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Select } from 'antd';
import { setLoadDetailsStatusData } from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';
import NotesModal from './NotesModal';
import EFSListModal from './EFSListModal';

const SelectAndNote = ({ resource, rowState, page, type, loadId }) => {
  const dispatch = useDispatch();
  const { loadDetails } =  CallCheckLoadsSelectors();
  const [ orderNotesModalIsOpen, setOrderNotesModalIsOpen ] = useState(false);
  const [ EFSListModalIsOpen, setEFSListModalIsOpen ] = useState(false);
  const { pickStopStatus, dropStopStatus, loadPickStopCommentsCount, loadDropStopCommentsCount } = loadDetails || {};
  const status = type === 'pick' ? pickStopStatus : dropStopStatus;
  const notesCount = type === 'pick' ? loadPickStopCommentsCount : loadDropStopCommentsCount;

  const selectNameOptionsLoadStatus = [
    { name: '-', id: 0 },
    { name: 'Ready to be Picked Up', id: 1 },
    { name: 'In Transit', id: 2 },
    { name: 'Delivered ', id: 3 },
    { name: 'Delayed', id: 4 },
  ];
  const selectOptionsLoadStatus = { null: '-', 0: '-', 1: 'Ready to be Picked Up', 2: 'In Transit', 3: 'Delivered', 4: 'Delayed' };

  const handleSelectChangeStatus = value => {
    if (value !== status) {
      setTimeout(() => {
        dispatch(setLoadDetailsStatusData(resource, page, value, rowState, type, loadId));
      }, 100);
    }
  };

  return (
    <div>
      <div className='status-header'>
        <div className='status-header__title-status'>{type === 'pick' ? 'Pick Status' : 'Drop Status'}</div>
        <div className='status-header__title-notes' onClick={() => setOrderNotesModalIsOpen(true)}>Notes</div>
        {type === 'pick' && <div className='status-header__title-notes load-details__add-efs' onClick={() => setEFSListModalIsOpen(true)}>Add EFS</div>}
      </div>
      <div className='status-data'>
        <div className='status-select'>
          <Select
            value={selectOptionsLoadStatus[`${status}`]}
            className='call-check-loads__select-arrow'
            onChange={handleSelectChangeStatus}
            defaultValue={selectOptionsLoadStatus[`${status}`]}>
            {selectNameOptionsLoadStatus.map((item, index) => (
              <Select.Option key={index} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div onClick={() => setOrderNotesModalIsOpen(true)} className='notes-count'>{notesCount}</div>
        {type === 'pick' && <div onClick={() => setEFSListModalIsOpen(true)} className='efs-count'>{loadDetails.efsAmount}</div>}
      </div>
      {orderNotesModalIsOpen && (
        <NotesModal
          orderNotesModalIsOpen={orderNotesModalIsOpen}
          setOrderNotesModalIsOpen={setOrderNotesModalIsOpen}
          rowState={rowState}
          resource={resource}
          page={page}
          loadType={type}
          isLoad
        />
      )}
      {EFSListModalIsOpen && (
        <EFSListModal
          EFSListModalIsOpen={EFSListModalIsOpen}
          setEFSListModalIsOpen={setEFSListModalIsOpen}
          rowState={rowState}
          resource={resource}
          page={page}
          loadType={type}
        />
      )}
    </div>
  );
};

export default SelectAndNote;
